import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  Pagination,
} from "semantic-ui-react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  UPDATE_PRODUCT_GROUP_PAGE_NUMBER,
  SG_GET_PRODUCT_GROUP,
  RESET_PRODUCT_GROUP,
} from "constants/actions";

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let ReloadPage = searchParams.get("reload");

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(1);

  const { get_product_group } = useSelector(
    (state) => ({
      get_product_group: state.product_group.product_group,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch({
      type: RESET_PRODUCT_GROUP,
    });
    dispatch({
      type: SG_GET_PRODUCT_GROUP,
    });
  }, [dispatch]);

  useEffect(() => {
    setResults(get_product_group?.results);
    setPage(get_product_group?.pageNumber);
    setTotalPages(
      Math.ceil(get_product_group?.count / get_product_group?.page_size)
    );
    if (get_product_group?.count % get_product_group?.page_size) {
      setTotalPages(
        Math.ceil(get_product_group?.count / get_product_group?.page_size)
      );
    }
  }, [get_product_group, page, ReloadPage]);

  function handlePageChange(e, { activePage }) {
    setPage(activePage);
    dispatch({
      type: UPDATE_PRODUCT_GROUP_PAGE_NUMBER,
      payload: activePage,
    });
    dispatch({
      type: SG_GET_PRODUCT_GROUP,
      payload: `page=${activePage}`
    });
  }

  function EditTemplate(templateId) {
    navigate(`/app/product/group/edit/${templateId}`);
  }

  function TemplateDetails(templateId) {
    navigate(`/app/product/group/details/${templateId}`);
  }

  return (
    <>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Order</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {results &&
              results.map((product, index) => (
                <tr key={index}>
                  <td>{product.id}</td>
                  <td>{product.name}</td>
                  <td>{product.sort_order}</td>
                  <td>{product.description}</td>
                  <td>
                    <Clickable onClick={() => EditTemplate(product?.id)}>
                      Edit{" "}
                    </Clickable>{" "}
                    |
                    <Clickable onClick={() => TemplateDetails(product.id)}>
                      Details{" "}
                    </Clickable>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>

      <Pagination
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        activePage={page}
        totalPages={totalPages ? totalPages : 0}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default List;

const TableContainer = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f4f4f4;
  }
`;

const Clickable = styled.span`
  color: blue;
  cursor: pointer;
  &:hover {
    color: red;
  }
`;
